export * from './Dot';

import Dot from './Dot';
export default Dot;

export * from './Variants/DownvoteDot';
export * from './Variants/AddDot';
